"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteFaqMutation = exports.useFaqByIdQuery = exports.useGetFaqsQuery = exports.useAddOrUpdateFaqMutation = exports.FaqApi = exports.prepareHeaders = void 0;
const react_1 = require("@reduxjs/toolkit/query/react");
const http_1 = require("../../http");
const storage_1 = require("../../storage");
const Utils_1 = require("../../Utils");
const prepareHeaders = (headers, { getState }) => {
    var _a, _b;
    const token = (_a = getState().user.token) !== null && _a !== void 0 ? _a : (_b = storage_1.AppStorage.getItem("user")) === null || _b === void 0 ? void 0 : _b.token;
    if (token) {
        headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
};
exports.prepareHeaders = prepareHeaders;
exports.FaqApi = (0, react_1.createApi)({
    reducerPath: "faqApi",
    tagTypes: ["faq", "faqList", "faqById"],
    baseQuery: (0, react_1.fetchBaseQuery)({
        baseUrl: `${http_1.ApiBaseUrl}`,
        prepareHeaders: exports.prepareHeaders,
    }),
    endpoints: (builder) => ({
        addOrUpdateFaq: builder.mutation({
            invalidatesTags: ["faq", "faqList", "faqById"],
            query: ({ id, data }) => {
                if (id) {
                    return {
                        url: `faqs/${id}`,
                        method: "PUT",
                        body: data,
                    };
                }
                return {
                    url: `faqs`,
                    method: "POST",
                    body: data,
                };
            },
        }),
        getFaqs: builder.query({
            providesTags: ["faqList"],
            query: (query) => (0, Utils_1.QueryUrl)("faqs", query),
        }),
        faqById: builder.query({
            query: (id) => `faqs/${id}`,
            providesTags: ["faqById"],
        }),
        deleteFaq: builder.mutation({
            query: (id) => ({
                url: `faqs/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["faq", "faqList", "faqById"],
        }),
    }),
});
exports.useAddOrUpdateFaqMutation = exports.FaqApi.useAddOrUpdateFaqMutation, exports.useGetFaqsQuery = exports.FaqApi.useGetFaqsQuery, exports.useFaqByIdQuery = exports.FaqApi.useFaqByIdQuery, exports.useDeleteFaqMutation = exports.FaqApi.useDeleteFaqMutation;
